module.exports = __webpack_public_path__ + "img/红花.809ac831.jpg";